(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animated-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const themeColor = document.querySelector('meta[name="theme-color"]');
    const originalColor = themeColor ? themeColor.getAttribute('content') : '';
    let tinted = null;

    function setTint(active) {
      if (active === tinted) return;
      tinted = active;
      document.documentElement.classList.toggle('artwork-announcement-at-top', active);
      if (themeColor) {
        themeColor.setAttribute('content', active ? '#490000' : originalColor || '');
      }
    }

    function updateTint() {
      const announcement = document.querySelector('[data-artwork-announcement-tint]');
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const atTop = window.scrollY <= 1;
      const visible = announcement && announcement.getBoundingClientRect().bottom > 0;
      setTint(Boolean(mobile && atTop && visible));
    }

    updateTint();
    window.addEventListener('scroll', updateTint, { passive: true });
    window.addEventListener('resize', updateTint);
    window.addEventListener('pageshow', updateTint);
    document.addEventListener('shopify:section:load', updateTint);
    document.addEventListener('shopify:section:unload', () => setTint(false));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diwali-whats-inside"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('diwali-inside')) {
    customElements.define('diwali-inside', class extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.diwali-inside__item'));
        if (!this.items.length) return;
        this.cards = this.items.map((item) => item.querySelector('.diwali-inside__card'));
        this.grid = this.querySelector('.diwali-inside__grid');
        this.moving = new Set();
        this.onScroll = () => {
          if (!this.enabled || !this.inView || this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.renderMotion();
          });
        };
        this.mobile = matchMedia('(max-width: 749px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.progress = this.querySelector('.diwali-inside__progress');
        this.viewport = this.querySelector('.diwali-inside__viewport');
        this.counter = this.querySelector('[data-di-current]');
        this.steps = Array.from(this.querySelectorAll('.diwali-inside__step'));
        this.cartBars = Array.from(document.querySelectorAll('sticky-product-atc, .sticky-product-atc'));
        this.scheduleLayout = () => {
          clearTimeout(this.resizeTimer);
          this.resizeTimer = setTimeout(() => this.configure(), 120);
        };
        this.onResize = () => {
          const width = this.clientWidth;
          const height = this.viewport.offsetHeight || document.documentElement.clientHeight;
          if (width !== this.layoutWidth || height !== this.layoutHeight) this.scheduleLayout();
        };
        this.onSelect = (event) => {
          if (!this.mobile.matches) return;
          const item = this.items.find((card) => card.dataset.blockId === event.detail.blockId);
          if (item) item.scrollIntoView({ block: 'start', behavior: 'instant' });
        };
        this.mobile.addEventListener('change', this.scheduleLayout);
        this.reduced.addEventListener('change', this.scheduleLayout);
        window.addEventListener('resize', this.onResize, { passive: true });
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.addEventListener('shopify:block:select', this.onSelect);
        this.sizeObserver = new ResizeObserver((entries) => {
          if (entries.some((entry) => entry.target !== this)) this.scheduleLayout();
          else this.onResize();
        });
        this.sizeObserver.observe(this);
        this.cartBars.forEach((bar) => this.sizeObserver.observe(bar));
        this.configure();
        document.fonts.ready.then(() => { if (this.isConnected) this.configure(); });
      }

      configure() {
        this.visibilityObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.enabled = false;
        this.classList.remove('is-stacked', 'is-measuring');
        this.style.removeProperty('--di-content-height');
        this.style.removeProperty('--di-media-height');
        this.items.forEach((item, index) => {
          item.classList.remove('is-past', 'is-previous', 'is-moving');
          this.cards[index].style.removeProperty('transform');
        });
        this.moving.clear();
        this.layoutWidth = this.clientWidth;
        this.layoutHeight = this.viewport.offsetHeight || document.documentElement.clientHeight;
        if (!this.mobile.matches) return;
        const contentHeight = Math.ceil(Math.max(...this.items.map((item) => item.querySelector('.diwali-inside__content').offsetHeight)));
        this.style.setProperty('--di-content-height', `${contentHeight}px`);
        const minimumClearance = parseFloat(getComputedStyle(this).getPropertyValue('--di-bottom-clearance')) || 104;
        const cartClearance = Math.max(0, ...this.cartBars.map((bar) => {
          const bottom = parseFloat(getComputedStyle(bar).bottom) || 0;
          return bar.offsetHeight + Math.max(0, bottom) + 16;
        }));
        const bottomClearance = Math.max(minimumClearance, cartClearance);
        this.style.setProperty('--di-reserved-bottom', `${bottomClearance}px`);
        if (this.reduced.matches || this.dataset.motion !== 'true' || this.items.length < 2) return;
        this.classList.add('is-stacked');
        this.top = parseFloat(getComputedStyle(this.progress).top) + this.progress.offsetHeight + 20;
        this.style.setProperty('--di-card-top', `${this.top}px`);
        const availableHeight = Math.floor(this.layoutHeight - this.top - bottomClearance - 16);
        const mediaHeight = Math.floor(Math.min(440, this.items[0].clientWidth - 2, availableHeight - contentHeight - 2));
        if (mediaHeight < 150) {
          this.classList.remove('is-stacked');
          return;
        }
        this.style.setProperty('--di-media-height', `${mediaHeight}px`);
        if (Math.max(...this.items.map((item) => item.offsetHeight)) > availableHeight) {
          this.classList.remove('is-stacked');
          return;
        }
        this.enabled = true;
        // Cache normal-flow positions once; scrolling needs only one geometry read.
        this.classList.add('is-measuring');
        const gridTop = this.grid.getBoundingClientRect().top;
        this.flowTops = this.items.map((item) => item.getBoundingClientRect().top - gridTop);
        this.cardHeight = this.items[0].offsetHeight;
        this.classList.remove('is-measuring');
        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          this.inView = entry.isIntersecting;
          if (this.inView) this.onScroll();
        }, { rootMargin: '200px 0px' });
        this.visibilityObserver.observe(this);
        this.active = -1;
        this.renderMotion();
      }

      renderMotion() {
        if (!this.enabled) return;
        const gridTop = this.grid.getBoundingClientRect().top;
        const clamp = (value) => Math.min(1, Math.max(0, value));
        let current = 0;
        while (current < this.items.length - 1 && gridTop + this.flowTops[current + 1] <= this.top) current++;
        const next = current + 1;
        const nextTop = next < this.items.length ? gridTop + this.flowTops[next] : Infinity;
        const overlap = clamp((this.top + this.cardHeight - nextTop) / this.cardHeight);
        const active = overlap >= 0.55 ? next : current;
        this.setActive(active);

        // Only the outgoing and arriving cards receive compositor-only updates.
        const moving = new Set([current]);
        if (next < this.items.length && nextTop < this.layoutHeight + 80) moving.add(next);
        this.moving.forEach((index) => {
          if (!moving.has(index)) {
            this.items[index].classList.remove('is-moving');
            this.cards[index].style.removeProperty('transform');
          }
        });
        moving.forEach((index) => {
          if (!this.moving.has(index)) this.items[index].classList.add('is-moving');
        });
        this.moving = moving;

        const arrival = clamp(1 - (gridTop + this.flowTops[current] - this.top) / this.cardHeight);
        const tilt = current % 2 ? -1 : 1;
        this.cards[current].style.transform = `translate3d(0, ${(24 * (1 - arrival) - 14 * overlap).toFixed(2)}px, 0) rotate(${(tilt * (1.8 * (1 - arrival) - 1.2 * overlap)).toFixed(3)}deg) scale(${(0.96 + 0.04 * arrival - 0.06 * overlap).toFixed(4)})`;
        if (moving.has(next)) {
          const reveal = clamp(1 - (nextTop - this.top) / this.cardHeight);
          const nextTilt = next % 2 ? -1 : 1;
          this.cards[next].style.transform = `translate3d(0, ${(24 * (1 - reveal)).toFixed(2)}px, 0) rotate(${(nextTilt * 1.8 * (1 - reveal)).toFixed(3)}deg) scale(${(0.96 + 0.04 * reveal).toFixed(4)})`;
        }
      }

      setActive(active) {
        if (this.active === active) return;
        this.active = active;
        this.counter.textContent = String(active + 1).padStart(2, '0');
        this.items.forEach((item, index) => {
          item.classList.toggle('is-past', index < active);
          item.classList.toggle('is-previous', index === active - 1);
          this.steps[index].classList.toggle('is-past', index < active);
          this.steps[index].classList.toggle('is-active', index === active);
        });
      }

      disconnectedCallback() {
        if (!this.onResize) return;
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('scroll', this.onScroll);
        this.mobile.removeEventListener('change', this.scheduleLayout);
        this.reduced.removeEventListener('change', this.scheduleLayout);
        this.removeEventListener('shopify:block:select', this.onSelect);
        this.visibilityObserver?.disconnect();
        this.sizeObserver.disconnect();
        cancelAnimationFrame(this.frame);
        clearTimeout(this.resizeTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["india-wakes-up-fragrances"] && !Shopify.designMode) return;
  try {
    
  const initializeFragrancePagination = (section) => {
    const sliderComponent = section.querySelector('.fragrance-showcase__slider');
    const slider = sliderComponent?.querySelector('[id^="Slider-"]');
    const pagination = sliderComponent?.querySelector('[data-fragrance-pagination]');
    const dotWrapper = pagination?.querySelector('.slideshow__control-wrapper');

    if (!sliderComponent || !slider || !pagination || !dotWrapper || sliderComponent.dataset.dotsInitialized) return;

    sliderComponent.dataset.dotsInitialized = 'true';

    let scrollPositions = [];
    let scrollFrame;

    const updateActiveDot = () => {
      if (!scrollPositions.length) return;

      const currentPosition = slider.scrollLeft;
      let activeIndex = 0;
      let closestDistance = Infinity;

      scrollPositions.forEach((position, index) => {
        const distance = Math.abs(position - currentPosition);
        if (distance < closestDistance) {
          closestDistance = distance;
          activeIndex = index;
        }
      });

      dotWrapper.querySelectorAll('.slider-counter__link').forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('slider-counter__link--active', isActive);
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    };

    const renderDots = () => {
      const slides = Array.from(slider.querySelectorAll('[id^="Slide-"]')).filter((slide) => slide.clientWidth > 0);
      const maximumScroll = Math.max(0, slider.scrollWidth - slider.clientWidth);
      const firstSlideOffset = slides[0]?.offsetLeft || 0;
      const uniquePositions = new Set();

      slides.forEach((slide) => {
        uniquePositions.add(Math.round(Math.min(Math.max(slide.offsetLeft - firstSlideOffset, 0), maximumScroll)));
      });

      scrollPositions = Array.from(uniquePositions);

      if (scrollPositions.length < 2) {
        pagination.hidden = true;
        dotWrapper.replaceChildren();
        return;
      }

      pagination.hidden = false;
      dotWrapper.replaceChildren();

      scrollPositions.forEach((position, index) => {
        const button = document.createElement('button');
        const dot = document.createElement('span');

        button.type = 'button';
        button.className = 'slider-counter__link slider-counter__link--dots link';
        button.setAttribute(
          'aria-label',
          `${pagination.dataset.slideLabel} ${index + 1} ${pagination.dataset.ofLabel} ${scrollPositions.length}`
        );
        button.setAttribute('aria-controls', slider.id);
        dot.className = 'dot';
        button.appendChild(dot);
        button.addEventListener('click', () => slider.scrollTo({ left: position, behavior: 'smooth' }));
        dotWrapper.appendChild(button);
      });

      updateActiveDot();
    };

    slider.addEventListener('scroll', () => {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(updateActiveDot);
    }, { passive: true });

    const resizeObserver = new ResizeObserver(renderDots);
    resizeObserver.observe(slider);
    renderDots();
  };

  const initializeAllFragrancePagination = (container = document) => {
    container.querySelectorAll('.fragrance-showcase').forEach(initializeFragrancePagination);
  };

  initializeAllFragrancePagination();

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllFragrancePagination(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["india-wakes-up-vignettes"] && !Shopify.designMode) return;
  try {
    
  const initializeVignetteCarousel = (section) => {
    const sliderComponent = section.querySelector('.editorial-vignettes__slider');
    const slider = sliderComponent?.querySelector('[id^="Slider-"]');
    const slides = Array.from(slider?.querySelectorAll('[id^="Slide-"]') || []);
    const previousButton = sliderComponent?.querySelector('button[name="previous"]');
    const nextButton = sliderComponent?.querySelector('button[name="next"]');
    const pagination = sliderComponent?.querySelector('[data-vignette-pagination]');
    const dotWrapper = pagination?.querySelector('.slideshow__control-wrapper');

    if (
      !sliderComponent ||
      !slider ||
      !previousButton ||
      !nextButton ||
      !pagination ||
      !dotWrapper ||
      sliderComponent.dataset.carouselInitialized
    ) return;

    sliderComponent.dataset.carouselInitialized = 'true';

    const desktopMedia = window.matchMedia('(min-width: 750px)');
    const reducedMotionMedia = window.matchMedia('(prefers-reduced-motion: reduce)');
    const autoplaySpeed = Number(section.dataset.autoplaySpeed) || 5000;
    let pagePositions = [];
    let autoplayTimer;
    let scrollFrame;
    let isPaused = false;

    const getActivePageIndex = () => {
      let activeIndex = 0;
      let closestDistance = Infinity;

      pagePositions.forEach((position, index) => {
        const distance = Math.abs(position - slider.scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          activeIndex = index;
        }
      });

      return activeIndex;
    };

    const updateActiveDot = () => {
      const activeIndex = getActivePageIndex();

      dotWrapper.querySelectorAll('.slider-counter__link').forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('slider-counter__link--active', isActive);
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    };

    const stopAutoplay = () => {
      window.clearInterval(autoplayTimer);
      autoplayTimer = undefined;
    };

    const startAutoplay = () => {
      stopAutoplay();

      if (!desktopMedia.matches || reducedMotionMedia.matches || isPaused || pagePositions.length < 2) return;

      autoplayTimer = window.setInterval(() => {
        const activeIndex = getActivePageIndex();
        const nextIndex = activeIndex === pagePositions.length - 1 ? 0 : activeIndex + 1;
        slider.scrollTo({ left: pagePositions[nextIndex], behavior: 'smooth' });
      }, autoplaySpeed);
    };

    const renderDots = () => {
      const slidesPerPage = desktopMedia.matches ? 2 : 1;
      const maximumScroll = Math.max(0, slider.scrollWidth - slider.clientWidth);
      const firstSlideOffset = slides[0]?.offsetLeft || 0;
      const uniquePositions = new Set();

      slides.forEach((slide, index) => {
        if (index % slidesPerPage !== 0) return;
        uniquePositions.add(Math.round(Math.min(Math.max(slide.offsetLeft - firstSlideOffset, 0), maximumScroll)));
      });

      pagePositions = Array.from(uniquePositions);
      previousButton.dataset.step = String(slidesPerPage);
      nextButton.dataset.step = String(slidesPerPage);
      dotWrapper.replaceChildren();

      pagePositions.forEach((position, index) => {
        const button = document.createElement('button');
        const dot = document.createElement('span');

        button.type = 'button';
        button.className = 'slider-counter__link slider-counter__link--dots link';
        button.setAttribute(
          'aria-label',
          `${pagination.dataset.slideLabel} ${index + 1} ${pagination.dataset.ofLabel} ${pagePositions.length}`
        );
        button.setAttribute('aria-controls', slider.id);
        dot.className = 'dot';
        button.appendChild(dot);
        button.addEventListener('click', () => {
          slider.scrollTo({ left: position, behavior: 'smooth' });
          startAutoplay();
        });
        dotWrapper.appendChild(button);
      });

      pagination.hidden = pagePositions.length < 2;
      updateActiveDot();
      startAutoplay();
    };

    slider.addEventListener('scroll', () => {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(updateActiveDot);
    }, { passive: true });

    section.addEventListener('mouseenter', () => {
      isPaused = true;
      stopAutoplay();
    });

    section.addEventListener('mouseleave', () => {
      isPaused = false;
      startAutoplay();
    });

    section.addEventListener('focusin', () => {
      isPaused = true;
      stopAutoplay();
    });

    section.addEventListener('focusout', (event) => {
      if (section.contains(event.relatedTarget)) return;
      isPaused = false;
      startAutoplay();
    });

    slider.addEventListener('pointerdown', () => {
      isPaused = true;
      stopAutoplay();
    });

    slider.addEventListener('pointerup', () => {
      isPaused = false;
      startAutoplay();
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    const resizeObserver = new ResizeObserver(renderDots);
    resizeObserver.observe(slider);
    renderDots();
  };

  const initializeAllVignetteCarousels = (container = document) => {
    container.querySelectorAll('[data-vignette-carousel]').forEach(initializeVignetteCarousel);
  };

  initializeAllVignetteCarousels();

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllVignetteCarousels(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navratri-key-facts"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('navratri-key-facts')) {
    class NavratriKeyFacts extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.classList.add('is-visible');
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.classList.add('is-visible');
            this.observer.disconnect();
          },
          { threshold: 0.2 }
        );

        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }

    customElements.define('navratri-key-facts', NavratriKeyFacts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navratri-ritual-steps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ritual-steps')) {
    class RitualSteps extends HTMLElement {
      connectedCallback() {
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.reducedQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.timeline = this.querySelector('.ritual-steps__timeline');
        this.rows = Array.from(this.querySelectorAll('[data-ritual-card]'));
        this.nodes = Array.from(this.querySelectorAll('.ritual-steps__node'));
        this.trackFill = this.querySelector('.ritual-steps__track-fill');
        this.rafId = 0;
        this.isActive = false;

        this.onPreferenceChange = () => this.configureMotion();
        this.onScroll = () => this.scheduleUpdate();
        this.onResize = () => {
          this.layoutTrack();
          this.scheduleUpdate();
        };
        this.onBlockSelect = (event) => {
          const row = event.target.closest('[data-ritual-card]');
          if (!row || !this.contains(row)) return;
          row.style.setProperty('--motion-opacity', '1');
          row.style.setProperty('--motion-y', '0px');
          row.scrollIntoView({ block: 'center', behavior: this.reducedQuery.matches ? 'auto' : 'smooth' });
        };

        this.mobileQuery.addEventListener('change', this.onPreferenceChange);
        this.reducedQuery.addEventListener('change', this.onPreferenceChange);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        this.configureMotion();
      }

      disconnectedCallback() {
        this.teardownMotion();
        this.mobileQuery?.removeEventListener('change', this.onPreferenceChange);
        this.reducedQuery?.removeEventListener('change', this.onPreferenceChange);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      configureMotion() {
        this.teardownMotion();

        if (!this.mobileQuery.matches || this.reducedQuery.matches || !this.rows.length) {
          this.classList.remove('is-motion-ready');
          this.rows.forEach((row) => {
            row.style.removeProperty('--motion-opacity');
            row.style.removeProperty('--motion-y');
          });
          if (this.trackFill) this.trackFill.style.transform = this.reducedQuery.matches ? 'scaleY(1)' : '';
          return;
        }

        this.classList.add('is-motion-ready');
        this.intersectionObserver = new IntersectionObserver(
          (entries) => {
            const isIntersecting = entries.some((entry) => entry.isIntersecting);
            if (isIntersecting === this.isActive) return;
            this.isActive = isIntersecting;
            if (this.isActive) {
              window.addEventListener('scroll', this.onScroll, { passive: true });
              this.layoutTrack();
              this.scheduleUpdate();
            } else {
              window.removeEventListener('scroll', this.onScroll);
            }
          },
          { rootMargin: '35% 0px', threshold: 0 }
        );
        this.intersectionObserver.observe(this);

        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.timeline);
        window.addEventListener('resize', this.onResize, { passive: true });
        this.layoutTrack();
        this.scheduleUpdate();
      }

      teardownMotion() {
        this.intersectionObserver?.disconnect();
        this.resizeObserver?.disconnect();
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        if (this.rafId) cancelAnimationFrame(this.rafId);
        this.rafId = 0;
        this.isActive = false;
      }

      layoutTrack() {
        if (!this.timeline || this.nodes.length < 2 || !this.mobileQuery.matches) return;
        const timelineRect = this.timeline.getBoundingClientRect();
        const firstRect = this.nodes[0].getBoundingClientRect();
        const lastRect = this.nodes[this.nodes.length - 1].getBoundingClientRect();
        const firstCenter = firstRect.top - timelineRect.top + firstRect.height / 2;
        const lastCenter = lastRect.top - timelineRect.top + lastRect.height / 2;
        this.timeline.style.setProperty('--track-top', `${firstCenter}px`);
        this.timeline.style.setProperty('--track-height', `${Math.max(0, lastCenter - firstCenter)}px`);
      }

      scheduleUpdate() {
        if (this.rafId) return;
        this.rafId = requestAnimationFrame(() => {
          this.rafId = 0;
          this.updateMotion();
        });
      }

      updateMotion() {
        if (!this.mobileQuery.matches || this.reducedQuery.matches || !this.rows.length) return;

        const viewportHeight = window.innerHeight;
        const focusPoint = viewportHeight * 0.52;
        const firstRect = this.nodes[0].getBoundingClientRect();
        const lastRect = this.nodes[this.nodes.length - 1].getBoundingClientRect();
        const firstCenter = firstRect.top + firstRect.height / 2;
        const lastCenter = lastRect.top + lastRect.height / 2;
        const distance = Math.max(1, lastCenter - firstCenter);
        const progress = Math.max(0, Math.min(1, (focusPoint - firstCenter) / distance));

        if (this.trackFill) this.trackFill.style.transform = `scaleY(${progress})`;

        const fadeRange = Math.max(280, viewportHeight * 0.58);
        this.rows.forEach((row) => {
          const rect = row.getBoundingClientRect();
          const center = rect.top + rect.height / 2;
          const offset = center - focusPoint;
          const opacity = Math.max(0.1, Math.min(1, 1 - Math.abs(offset) / fadeRange));
          const motionY = Math.max(-20, Math.min(20, offset * 0.08));
          row.style.setProperty('--motion-opacity', opacity.toFixed(3));
          row.style.setProperty('--motion-y', `${motionY.toFixed(1)}px`);
        });
      }
    }

    customElements.define('ritual-steps', RitualSteps);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navratri-value-props"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('value-props-marquee')) {
    class ValuePropsMarquee extends HTMLElement {
      connectedCallback() {
        if (!('IntersectionObserver' in window)) {
          this.classList.add('is-in-view');
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            this.classList.toggle('is-in-view', entries.some((entry) => entry.isIntersecting));
          },
          { rootMargin: '80px 0px', threshold: 0 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }

    customElements.define('value-props-marquee', ValuePropsMarquee);
  }

  } catch(e) { console.error(e); }
})();
})();
